.mat-mdc-form-field{display:block}
/*# sourceMappingURL=user-sign-in.component-ZB4OJ25M.css.map */
